import { FC, useMemo } from 'react'
import classNames from 'classnames'
import { Image } from '@/atoms/Image'
import { useGiveawayContext } from '../../context/GiveawayContext'

interface Props {
  isFooter?: boolean
}

/** Width only; height scales from each logo's intrinsic aspect ratio. */
const LOGO_SIZES: Record<'main' | 'footer', number> = {
  main: 282,
  footer: 152,
}

export const GiveawayLogo: FC<Props> = ({ isFooter }) => {
  const { content } = useGiveawayContext()

  const logoUrl = useMemo(() => {
    if (isFooter && typeof content.footerLogoUrl === 'string') {
      return content.footerLogoUrl
    }
    return content.logoUrl || ''
  }, [content.footerLogoUrl, content.logoUrl, isFooter])

  const width = LOGO_SIZES[isFooter ? 'footer' : 'main']

  return (
    <div
      className={classNames('relative mx-auto shrink-0 md:mx-0', isFooter && '!mx-0')}
      style={{ width: `${width}px` }}
    >
      <Image
        alt="logo"
        src={logoUrl}
        width={width}
        height={100}
        className="h-auto max-h-[150px] w-full object-contain md:object-left"
      />
    </div>
  )
}
